import { Temporal } from 'temporal-polyfill';

import {
  ExperienceAnalyteResponseV1,
  ExperienceCategoryResponseV1,
  ExperienceCategorySummaryResponseV1,
  ExperienceResponseV1
} from '@core/models/experience';
import { HealthProfile } from '@core/models/health-profile';

import { mockUser1 } from '../user/user-mock';

export const mockHealthProfile1: HealthProfile = {
  youtopianId: mockUser1.userId,
  youtopiaExperienceId: 'c54c0644-35cf-45db-9846-577aa41e772c',
  dayScore: 80,
  nOf1Enabled: true,
  startingLineComplete: true,
  previousDaysScores: [
    { date: Temporal.Now.plainDateISO().subtract({ days: 6 }).toLocaleString(), score: 40 },
    { date: Temporal.Now.plainDateISO().subtract({ days: 5 }).toLocaleString(), score: 50 },
    { date: Temporal.Now.plainDateISO().subtract({ days: 4 }).toLocaleString(), score: 60 },
    { date: Temporal.Now.plainDateISO().subtract({ days: 3 }).toLocaleString(), score: 70 },
    { date: Temporal.Now.plainDateISO().subtract({ days: 2 }).toLocaleString(), score: 80 },
    { date: Temporal.Now.plainDateISO().subtract({ days: 1 }).toLocaleString(), score: 85 },
    { date: Temporal.Now.plainDateISO().toLocaleString(), score: 90 }
  ]
};

export const mockExperienceAnalyte1: ExperienceAnalyteResponseV1 = {
  analyteId: '8c8ef1c9-ddf3-4b8c-847a-0183ec3a6b16',
  name: 'White Blood Cells',
  scoreDate: '2026-01-06T20:10:44.350Z',
  score: 90,
  resultDate: '2026-01-06T20:10:44.350Z',
  result: 7.2,
  resultUnits: '1000/mcL',
  historicalResults: [
    { date: '2025-06-06T20:10:44.350Z', result: 5.4, score: 82 },
    { date: '2025-10-06T20:10:44.350Z', result: 3.2, score: 68 },
    { date: '2026-01-06T20:10:44.350Z', result: 7.2, score: 90 }
  ],
  ranges: [
    {
      low: 0,
      high: 1,
      name: 'Panic Low',
      color: 'Red'
    },
    {
      low: 1.1,
      high: 3.3,
      name: 'Low',
      color: 'Orange'
    },
    {
      low: 3.4,
      high: 4.9,
      name: 'Low End',
      color: 'Yellow'
    },
    {
      low: 5,
      high: 7.5,
      name: 'Optimal',
      color: 'Green'
    },
    {
      low: 7.6,
      high: 10.8,
      name: 'High End',
      color: 'Yellow'
    },
    {
      low: 10.9,
      high: 49.9,
      name: 'High',
      color: 'Orange'
    },
    {
      low: 50,
      high: 100,
      name: 'Panic High',
      color: 'Red'
    }
  ]
};

export const mockExperienceAnalyte2: ExperienceAnalyteResponseV1 = {
  analyteId: 'acf3e97a-b675-465a-94e3-dd451610a7a6',
  name: 'Globulin',
  scoreDate: '2026-01-06T20:10:44.350Z',
  score: 62,
  resultDate: '2026-01-06T20:10:44.350Z',
  result: 1.2,
  resultUnits: 'g/dL',
  historicalResults: [
    { date: '2025-06-06T20:10:44.350Z', result: 2.8, score: 87 },
    { date: '2025-10-06T20:10:44.350Z', result: 2.2, score: 82 },
    { date: '2026-01-06T20:10:44.350Z', result: 1.2, score: 62 }
  ],
  ranges: [
    {
      low: 0,
      high: 1.4,
      name: 'Low',
      color: 'Orange'
    },
    {
      low: 1.5,
      high: 2.3,
      name: 'Low End',
      color: 'Yellow'
    },
    {
      low: 2.4,
      high: 2.8,
      name: 'Optimal',
      color: 'Green'
    },
    {
      low: 2.9,
      high: 4.5,
      name: 'High End',
      color: 'Yellow'
    },
    {
      low: 4.6,
      high: 10,
      name: 'High',
      color: 'Orange'
    }
  ]
};

export const mockExperienceCategorySummary1: ExperienceCategorySummaryResponseV1 = {
  categoryId: '67f1301b-de28-46ea-ba26-b299ce168b0b',
  categoryName: 'Immunity',
  scoreDate: '2026-01-06T20:10:44.350Z',
  score: 52,
  historicalScores: [
    { date: '2025-06-06T20:10:44.350Z', score: 34 },
    { date: '2025-10-06T20:10:44.350Z', score: 43 },
    { date: '2026-01-06T20:10:44.350Z', score: 52 }
  ]
};

export const mockExperienceCategoryDetail1: ExperienceCategoryResponseV1 = {
  ...mockExperienceCategorySummary1,
  analytes: [mockExperienceAnalyte1, mockExperienceAnalyte2]
};

export const mockExperienceCategorySummary2: ExperienceCategorySummaryResponseV1 = {
  categoryId: '3f3bc898-c422-42a5-aea2-ecd59451ad97',
  categoryName: 'Heart and Vascular',
  scoreDate: '2026-01-06T20:10:44.350Z',
  score: 57,
  historicalScores: [
    { date: '2025-06-06T20:10:44.350Z', score: 34 },
    { date: '2025-10-06T20:10:44.350Z', score: 43 },
    { date: '2026-01-06T20:10:44.350Z', score: 52 }
  ]
};

export const mockExperienceCategoryDetail2: ExperienceCategoryResponseV1 = {
  ...mockExperienceCategorySummary2,
  analytes: [mockExperienceAnalyte1, mockExperienceAnalyte2]
};

export const mockExperienceCategorySummary3: ExperienceCategorySummaryResponseV1 = {
  categoryId: 'dd6fd2b7-8b0f-4265-ba0b-916a72ab3153',
  categoryName: 'Prediabetic Indicators',
  scoreDate: '2026-01-06T20:10:44.350Z',
  score: 87,
  historicalScores: [
    { date: '2025-06-06T20:10:44.350Z', score: 34 },
    { date: '2025-10-06T20:10:44.350Z', score: 43 },
    { date: '2026-01-06T20:10:44.350Z', score: 52 }
  ]
};

export const mockExperienceCategoryDetail3: ExperienceCategoryResponseV1 = {
  ...mockExperienceCategorySummary3,
  analytes: [mockExperienceAnalyte1, mockExperienceAnalyte2]
};

export const mockExperienceCategorySummaries = [
  mockExperienceCategorySummary1,
  mockExperienceCategorySummary2,
  mockExperienceCategorySummary3
];

export const mockExperienceCategoryDetails = [
  mockExperienceCategoryDetail1,
  mockExperienceCategoryDetail2,
  mockExperienceCategoryDetail3
];

const mockExperience1OverallScore = mockExperienceCategorySummaries.length
  ? mockExperienceCategorySummaries.reduce((s, { score }) => s + score, 0) / mockExperienceCategorySummaries.length
  : 0;
export const mockExperience1: ExperienceResponseV1 = {
  experienceId: 'c54c0644-35cf-45db-9846-577aa41e772c',
  youtopianId: mockUser1.userId,
  youtopiaExperienceId: '1e132274-ad51-46a2-935a-093d4c3acfe8',
  name: 'The Starting Line™',
  scoreDate: '2026-01-06T20:10:44.350Z',
  expirationDate: '2026-04-06T20:10:44.350Z',
  overallScore: mockExperience1OverallScore,
  historicalScores: [
    { date: '2025-06-06T20:10:44.350Z', score: 34 },
    { date: '2025-10-06T20:10:44.350Z', score: 43 },
    { date: '2026-01-06T20:10:44.350Z', score: mockExperience1OverallScore }
  ],
  categories: mockExperienceCategorySummaries
};
